export const CHANGE_IMG_SHOW_INDEX = 'houseDetail/CHANGE_IMG_SHOW_INDEX';
export const UPDATA_HOUSE_DATA = 'houseDetail/UPDATA_HOUSE_DATA';
export const GET_HOUSE_DATA = 'houseDetail/GET_HOUSE_DATA';
const initialState = {
  currentImgIndex: 0,
  houseData: {
    address: '',                                 //地址
    build_area: '',                              //面积
    plot_name: '',                               //小区名称
    house_no: '',                                //房源编号
    house_description: '',                        //描述
    rent_scope: '',                              //整租
    create_on: '',                               //发布日期
    districts: '',                               //区县名
    house_orientations: '',                      //房屋朝向
    bldroom_count: '',                           //室
    hall_count: '',                              //厅
    decoration_levels: '',                       //装修标准
    create_peoplename: '',                       //创建人名称
    landlord_telephone: '',                      //创建人联系电话
    pay_type_request_mortgage_month: '',         //要求支付方式
    pay_type_request_pay_month: '',              //要求支付方式
    warm_types: '',                               //供暖方式
    equipments: [],                               //配套设施
    layer_levels: '',                             //楼层类型
    building_layers_u: '',                        //总层数
    audit_no: '',                                 //房源编号
    audit_status: '',                              //核验状态
    trafficSituation: '',                          //交通情况
    price_request: '',                              //租金
    landlord_type: '',                            //people_or_organize
    houseImgData: [
      {
        src: '',
        housePart: '',
        alt: '',
      }
    ],
    imgSrc: '',
    house_title: '',
    visitors:'',
    sex:'',
    midNo:''
  },
};

const houseDataReducer = (houseData = {}, action)=> {
  switch (action.type) {
    case UPDATA_HOUSE_DATA:
      return {
        ...houseData,
        [action.subType]: action.data
      }
    case GET_HOUSE_DATA:
      return action.data
    default:
      return houseData
  }
}
const currentImgIndexReducer = (currentImgIndex = 0, action)=> {
  switch (action.type) {
    case CHANGE_IMG_SHOW_INDEX:
      return action.data
    default:
      return currentImgIndex
  }
}


export default (state = initialState, action) => {
  return {
    houseData: houseDataReducer(state.houseData, action),
    currentImgIndex: currentImgIndexReducer(state.currentImgIndex, action)
  };
}


export const dispatch_func = {
  changeImgShowIndex: (data) => {
    return dispatch => {
      dispatch({
        type: CHANGE_IMG_SHOW_INDEX,
        data: data
      });
    }
  },
  updateHouseData: (data, type) => {
    return dispatch => {
      dispatch({
        type: UPDATA_HOUSE_DATA,
        data: data,
        subType: type
      });
    }
  },
  getHouseData: (data) => {
    return dispatch => {
      dispatch({
        type: GET_HOUSE_DATA,
        data: data
      });
    }
  },


};


// WEBPACK FOOTER //
// ./src/modules/houseDetail.js